const Aux = ({ children }) => children ? children : null;
export default Aux;



// WEBPACK FOOTER //
// ./src/components/aux.js